import { defineMessages } from 'react-intl';

/* eslint-disable perfectionist/sort-object-types */
export const messages: {
	shortcutActionOpenMenuLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	/* eslint-enable perfectionist/sort-object-types */
} = defineMessages({
	shortcutActionOpenMenuLabel: {
		id: 'navigation.global-shortcuts.shortcut-action.open-menu-label',
		description: 'Label for shortcut action items button',
		defaultMessage: 'open menu',
	},
});
